module.exports = __webpack_public_path__ + "73865ee966ff980fe4e292f03b960e00.png";